
import Vue from "vue";
import mixin from "@/mixin/mixin";

export interface DataType {}

export default Vue.extend({
  name: "IntegrationFutureshop",
  mixins: [mixin],
  components: {},
  data(): DataType {
    return {};
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    newMakeshopIntegration: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dialogMakeshop: {
      get(): boolean {
        return (this as any).value;
      },
      set(newValue: boolean) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    integrateMakeshop() {
      this.$emit("integrate", {
        newMakeshopIntegration: this.newMakeshopIntegration,
      });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  mounted() {},
});
